import React, {ReactElement, useMemo} from 'react';
import {Icon, MenuItem, SxProps, Theme} from '@mui/material';
import {useRecordContext} from 'components/record/useRecordContext';
import {RecordType} from 'components/record/RecordContext';

const ActionMenuItemLink = (props: ActionMenuItemLinkProps) => {
  const {label, sx = {}, icon = <Icon />, href} = props;
  const {record} = useRecordContext();

  const hrefTo = useMemo(() => {
    if (typeof href === 'function') {
      return href(record);
    }
    return href;
  }, [record, href]);

  return (
    <MenuItem component="a" href={hrefTo} sx={{...sx}} target="_blank" rel="noopener noreferrer">
      {icon}
      {label}
    </MenuItem>
  );
};

export default ActionMenuItemLink;

export type ActionMenuItemLinkProps = {
  href: string | ((record?: RecordType) => string);
  label: string;
  icon?: ReactElement;
  sx?: SxProps<Theme>;
};
